import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ownerinfo',
  templateUrl: './ownerinfo.component.html',
  styleUrls: ['./ownerinfo.component.css']
})
export class OwnerinfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
